/* build/tpl */
import deps from './deps/pickDeep.js';
import getPickDeep from './getPickDeep.js';
export default getPickDeep(deps);
